{
  "name": "trade-front-admin",
  "version": "6.10.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve -c dev -o --port 4300 --host 0.0.0.0",
    "serve-dev": "ng serve -c dev -o --port 4300 --host 0.0.0.0",
    "serve-qa": "ng serve -c qa -o --port 4300",
    "serve-prod": "ng serve -c prod -o --port 4300",
    "build-dev": "ng build -c dev --output-hashing=all --named-chunks",
    "build-qa": "ng build -c qa --output-hashing=all --named-chunks",
    "build-prod": "ng build -c prod --output-hashing=all --named-chunks",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "compodoc": "npx compodoc -p tsconfig.doc.json -s --port=4400"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.14",
    "@angular/cdk": "^19.2.18",
    "@angular/common": "^19.2.14",
    "@angular/compiler": "^19.2.14",
    "@angular/core": "^19.2.14",
    "@angular/fire": "^19.2.0",
    "@angular/forms": "^19.2.14",
    "@angular/localize": "^19.2.14",
    "@angular/material": "^19.2.18",
    "@angular/material-moment-adapter": "^19.2.18",
    "@angular/platform-browser": "^19.2.14",
    "@angular/platform-browser-dynamic": "^19.2.14",
    "@angular/router": "^19.2.14",
    "@danielmoncada/angular-datetime-picker": "^19.1.2",
    "@ng-bootstrap/ng-bootstrap": "^18.0.0",
    "@ngrx/store": "^19.2.1",
    "@ngrx/store-devtools": "^19.2.1",
    "@popperjs/core": "^2.10.2",
    "@primeng/themes": "^18.0.2",
    "@shoelace-style/shoelace": "^2.2.0",
    "@types/jquery": "^3.5.13",
    "angular-draggable-droppable": "^6.1.0",
    "apexcharts": "^4.7.0",
    "bootstrap": "^5.1.3",
    "chart.js": "^3.8.0",
    "crypto-js": "^4.2.0",
    "exceljs": "^4.3.0",
    "file-saver": "^2.0.5",
    "jquery": "^3.6.0",
    "jszip": "^3.10.1",
    "moment": "^2.29.1",
    "ng-apexcharts": "^1.15.0",
    "ngx-bootstrap": "^19.0.2",
    "ngx-infinite-scroll": "^19.0.0",
    "ngx-spinner": "^19.0.0",
    "pdfjs-dist": "^3.11.174",
    "primeicons": "^7.0.0",
    "primelocale": "^2.2.3",
    "primeng": "^19.1.3",
    "rxjs": "^7.8.2",
    "tslib": "^2.3.1",
    "util": "^0.12.4",
    "xlsx": "^0.17.5",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.15",
    "@angular/cli": "^19.2.15",
    "@angular/compiler-cli": "^19.2.14",
    "@compodoc/compodoc": "^1.1.18",
    "@types/crypto-js": "^4.2.2",
    "@types/file-saver": "^2.0.5",
    "@types/jasmine": "^3.10.3",
    "@types/node": "^12.20.42",
    "convert-video": "^1.0.0",
    "jasmine-core": "~3.8.0",
    "karma": "^6.3.11",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.0.3",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "~1.7.0",
    "typescript": "5.6"
  }
}
